/* import resolveConfig from "tailwindcss/resolveConfig"; */
/* import tailwindConfigFile from "@tailwindConfig"; */

/* export const tailwindConfig = () => {
  return resolveConfig(tailwindConfigFile);
}; */

import config from '@/config';
import { Money } from '@/types/util';
import { clsx, type ClassValue } from 'clsx';
import parsePhoneNumberFromString from 'libphonenumber-js';
import { twMerge } from 'tailwind-merge';

export const hexToRGB = (h: string): string => {
  let r = '0';
  let g = '0';
  let b = '0';
  if (h.length === 4) {
    r = `0x${h[1]}${h[1]}`;
    g = `0x${h[2]}${h[2]}`;
    b = `0x${h[3]}${h[3]}`;
  } else if (h.length === 7) {
    r = `0x${h[1]}${h[2]}`;
    g = `0x${h[3]}${h[4]}`;
    b = `0x${h[5]}${h[6]}`;
  }
  return `${+r},${+g},${+b}`;
};

export const formatValue = (value: number | string) => {
  let num: number = typeof value == 'string' ? parseFloat(value) : value;

  return Intl.NumberFormat('sv-SE', {
    style: 'currency',
    currency: 'SEK',
    maximumSignificantDigits: 3,
    notation: 'compact',
  }).format(num);
};

export const formatMoney = (money: Money) => {
  const num = money.amount / 100;

  return Intl.NumberFormat('sv-SE', {
    style: 'currency',
    currency: money.currency ?? 'SEK',
    maximumSignificantDigits: 3,
    notation: 'standard',
  }).format(num);
};

export const formatThousands = (value: number | string) => {
  let num: number = typeof value == 'string' ? parseFloat(value) : value;

  return Intl.NumberFormat('sv-SE', {
    maximumSignificantDigits: 3,
    notation: 'compact',
  }).format(num);
};

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function generateSwishUrl(swishToken: string, paymentId: string, orderId: string, code: string): string {
  const callbackUrl = `${config.app.paymentflow.callbackUrl(code)}?paymentId=${paymentId}&orderId=${orderId}`;
  return `swish://paymentrequest?token=${swishToken}&callbackurl=${encodeURIComponent(callbackUrl)}`;
}

export const formatMobileNumber = (mobileNumber: string) => {
  const parsed = parsePhoneNumberFromString(mobileNumber, 'SE');
  return parsed?.formatNational();
};
